import { ca } from '@cian/analytics';
import { useCallback, useMemo } from 'react';
import { IFormattedOtherProject } from '../../../types/project';

const offerType = 'CSP';

interface IParams {
  builderId: number;
  projectId: number;
  otherProjects: IFormattedOtherProject[];
}

export const useAnalytics = ({ builderId, projectId, otherProjects }: IParams) => {
  const trackBuilderLinkClick = useCallback(() => {
    ca('eventSite', {
      ec: 'Card_CB',
      ea: 'Click',
      el: 'site_country_builders',
      products: [
        {
          position: 1,
          offerType,
          id: projectId,
          extra: {
            builderId,
          },
        },
      ],
    });
  }, [builderId, projectId]);

  const trackProjectLinkClick = useCallback((projectId: number, index: number) => {
    ca('eventSite', {
      ec: 'Card_CSP',
      ea: 'Click',
      el: 'HouseProjects',
      products: [
        {
          id: projectId,
          position: index + 1,
          offerType,
        },
      ],
    });
  }, []);

  const trackProjectsListChange = useCallback(() => {
    const products = otherProjects.map(({ id }, index) => ({
      id,
      offerType,
      position: index + 1,
    }));

    ca('eventSite', {
      ec: 'Card_CSP',
      ea: 'ListingCSP_sopr',
      products,
    });
  }, [otherProjects]);

  return useMemo(
    () => ({
      trackBuilderLinkClick,
      trackProjectLinkClick,
      trackProjectsListChange,
    }),
    [trackBuilderLinkClick, trackProjectLinkClick, trackProjectsListChange],
  );
};
